const supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || '').replace(/\/+$/, '');
const storageBucket = process.env.REACT_APP_SUPABASE_STORAGE_BUCKET || 'Product Images';

const encodePath = (path) => path.split('/').map(encodeURIComponent).join('/');

export const getFrontendAssetUrl = (filename) => {
  if (!supabaseUrl || !filename) {
    return '';
  }

  return `${supabaseUrl}/storage/v1/object/public/${encodeURIComponent(storageBucket)}/frontend/${encodePath(filename)}`;
};